module.exports = "/images/logo-sobatppt-49cb1459f19e119ce8a576e255abac1c.png";